/* eslint-disable @typescript-eslint/no-explicit-any */

import { CsbHelper, getConfig, getConfigValue, Job } from "@recruiting-solutions/rs-shared";
import { SearchRequest, SearchResponse } from "../models";

import { SearchService } from "./search.service";


class JobServiceController {


    public async loadJob(): Promise<Job | undefined> {
        if (!window) {
            return;
        }
        let jobId = await getJobId() || '';
        const csb = (window as any).csb;

        if (jobId !== '-1') {

            if (jobId.startsWith("_")) {
                console.log('loading preview job: ' + jobId);
                jobId = jobId.substr(1);
                csb.job = await this.getPreviewJob(jobId);
            } else {
                csb.job = await SearchService.getJob(jobId);
            }
            if (csb.job && !csb.job.isActive && window.location.pathname.indexOf('/job/') != -1) {
                const searchWrapper = document.getElementById('search-wrapper');
                if (searchWrapper) {
                    searchWrapper.style.display = "none";
                }
            }
            return csb.job as Job;
        }
        return undefined;
    }

    public async getJob(jobId: string) {
        return await SearchService.getJob(jobId);
    }

    getPreviewJob(jobId: string): any {
        const customerId = getConfigValue('customerId');
        const apiUrl = getConfigValue('functionsUrl');
        const locale = CsbHelper.getLocale();
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (res, _rej) => {
            const request: XMLHttpRequest = new XMLHttpRequest();
            request.open("GET", `${apiUrl}/getPreviewJob?customerId=${customerId}&jobId=${jobId}&locale=${locale}`);
            request.addEventListener('load', () => {
                if (request.status >= 200 && request.status < 300) {
                    const item = JSON.parse(request.responseText) as Job;
                    res(item);
                } else {
                    _rej(`Error loading Preview Job`);
                }
            });
            request.send();
        });
    }
    getPosting(jobId: string, isInternal: boolean) {
        const customerId = getConfigValue('customerId');
        const apiUrl = getConfigValue('functionsUrl');
        const postingData = { customerId: customerId, jobReqId: jobId, internal: isInternal };
        return fetch(`${apiUrl}/hasValidPosting`, {
            method: 'POST',
            body: JSON.stringify(postingData),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            return response.json();
        });
    }
    public async loadJobsByTemplate(templateIds: string[], skip = 0, take = 20): Promise<SearchResponse | undefined> {
        const searchRequest = new SearchRequest("*");
        const filter: string[] = [];
        templateIds.forEach(item => {
            filter.push(`template eq '${item}'`);
        });
        searchRequest.top = take;
        searchRequest.skip = skip;
        searchRequest.addFilter('(' + filter.join(' or ') + ')');

        return await SearchService.search(searchRequest);
    }

    public async loadJobsByCategories(categories: string[], brand: string, skip = 0, take = 20, orderBy?: string): Promise<SearchResponse | undefined> {

        const searchRequest = new SearchRequest("*");
        const filter: string[] = [];
        categories.forEach(item => {
            filter.push(`category eq '${item}'`);
        });
        if (brand) {
            searchRequest.addFilter(`brand eq '${brand}'`);
        }
        searchRequest.top = take;
        searchRequest.skip = skip;
        searchRequest.orderby = orderBy;
        searchRequest.addFilter('(' + filter.join(' or ') + ')');
        return await SearchService.search(searchRequest, false, false); //  categories, brand, skip, take, orderBy);
    }

    public async getTopJobs(brand: string, skip = 0, take = 9): Promise<Job[]> {
        const searchRequest = new SearchRequest("*");
        if (brand) {
            searchRequest.addFilter(`brand eq '${brand}'`);
        }
        searchRequest.addFilter(`isFeatured eq true`);
        searchRequest.top = take;
        searchRequest.skip = skip;
        return (await SearchService.search(searchRequest, false, false))?.jobs || [];
    }

    public async loadJobsByCategoriesCount(categories: string[], brand: string): Promise<number> {
        return (await this.loadJobsByCategories(categories, brand))?.count || 0;
    }

}

export const JobService = new JobServiceController();

export async function getJobId(): Promise<string | null> {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('csbJobId')) {
            const jobId = urlParams.get('csbJobId');
            console.log('Preview JobId from url:' + jobId);
            return Promise.resolve("_" + jobId);
        }
        if (urlParams.get('extJobId')) {
            const jobId = urlParams.get('extJobId');
            console.log('external JobId from url:' + jobId);
            return Promise.resolve(jobId);
        }
    } catch (error) {
        console.error(error);
    }
    if ((window as any).jobId) {
        return Promise.resolve((window as any).jobId);
    }
    let waitMs = getConfig().production ? 600000 : 1000;
    return new Promise(resolve => {
        // eslint-disable-next-line no-var
        var check = () => {
            const j2w = (window as any).j2w;
            if (
                j2w &&
                j2w.Apply &&
                j2w.Apply.Args &&
                j2w.Apply.Args.get() &&
                j2w.Apply.Args.get().applyWithLinkedIn2Config &&
                j2w.Apply.Args.get().applyWithLinkedIn2Config.internalId
            ) {
                let id = j2w.Apply.Args.get().applyWithLinkedIn2Config.internalId;
                if (!getConfigValue('idContainsLang')) {
                    id = id.split('-')[0];
                }
                resolve(id);
            } else if (j2w && j2w.SSO?.getJobID()) {
                let id = j2w.SSO?.getJobID();
                if (!getConfigValue('idContainsLang')) {
                    id = id.split('-')[0];
                }
                resolve(id);
            } else if ((waitMs -= 100) < 0) {
                resolve('-1');
            } else {
                setTimeout(check, 100);
            }
        };
        setTimeout(check, 100);
    });
}


export function getJob(): Promise<Job> {
    return new Promise((res) => {
        const interval = setInterval(() => {
            if (!window) {
                return;
            }
            const win = window as any;
            if (win.csb.job) {
                res(win.csb.job);
                clearInterval(interval);
            }
        }, 100);
    });
}

export function fillJobIfEmpty(that: { job: Job | undefined }, fallback?: any): any {
    getJob().then((job) => {
        if (!that.job) that.job = job;
    });
    return fallback;
}